import EditIncident from './EditIncident';

export default EditIncident;
